






import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

@Component
export default class ToggleInput extends Vue {
  @Prop({ default: 'Yes', type: String }) yesLabel!: string;
  @Prop({ default: 'No', type: String }) noLabel!: string;
  @Prop({ default: '0', type: String }) value!: string;

  localValue:boolean = false;

  mounted() {
    this.localValue = Boolean(Number(this.value));
  }

  @Watch("value")
  onValueChange(newValue: string) {
    const newValusAsBoolean = Boolean(Number(newValue));
    if (newValusAsBoolean !== this.localValue) {
      this.localValue = newValusAsBoolean;
    }
  }

  onChange() {
    this.$emit('update', this.localValue ? '1' : '0');
  }
}
